package com.wintermar.inspection.feature.presentation.inspection.landing

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.items
import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.presentation.inspection.landing.widget.InspectionLandingHeader
import com.wintermar.inspection.feature.presentation.inspection.landing.widget.InspectionLandingItemWide
import com.wintermar.inspection.feature.presentation.inspection.landing.widget.InspectionLandingPageHeader

actual fun LazyListScope.itemContent(
    data: List<InspectionModel>,
    onClick: (inspectionId: String) -> Unit,
    onMoreClick: (data: InspectionModel) -> Unit
) {
    stickyHeader {
        InspectionLandingHeader()
    }

    items(data) {
        InspectionLandingItemWide(
            data = it,
            onClick = { onClick(it.id) },
            onMoreClick = { onMoreClick(it) }
        )
    }
}

@Composable
actual fun BottomNewInspection(
    paddingValues: PaddingValues,
    dimension: AppDimension,
    onClick: () -> Unit
) {
    // no-op
}

@Composable
actual fun HeaderContent(
    onClick: () -> Unit
) {
    InspectionLandingPageHeader { onClick() }
}
